<template>
    <div>
        <SettingsCardTitle>
            {{ __('actions.edit_thing', {thing: __('payment.payment_methods')}) }}
        </SettingsCardTitle>

        <form>
            <div class="d-flex flex-row justify-content-start mb-3 flex-wrap">
                <div class="mb-1" v-for="(paymentMethod, id) in form.payment_methods" :key="id">
                    <label
                        class="kt-checkbox payment-method payment-md-method w-110px h-80px w-md-200px h-md-140px mr-3 border rounded p-4 pl-5"
                        :style="getCss(paymentMethod.icon_url)">
                        <input v-model="paymentMethod.active" type="checkbox">
                        <span class="m-2"/>
                    </label>
                    <p class="text-center">
                        {{ paymentMethod.name }}
                    </p>
                </div>
            </div>
        </form>

        <SaveAndEnableButton :for="form" @click="submitForm"/>
    </div>
</template>

<script>
import Navigation from './Nav/Navigation.vue'
import SettingsCardTitle from "@components/Form/SettingsCardTitle.vue";
import SaveAndEnableButton from "@components/Integrations/SaveAndEnableButton.vue";

export default {
    layout: Navigation,

    components: {SaveAndEnableButton, SettingsCardTitle},

    props: {
        store: Object,
        paymentMethods: Array,
    },

    data() {
        return {
            form: this.$inertia.form({
                payment_methods: this.paymentMethods,
            }),
        }
    },

    methods: {
        submitForm() {
            this.form.transform(
                (data) => {
                    return {
                        payment_methods: data.payment_methods
                            .filter(paymentMethod => paymentMethod.active)
                            .map(paymentMethod => paymentMethod.code),
                    }
                }
            ).post(this.$route('store.payment.update', this.store.id))
        },

        getCss(item) {
            return `background-image: url('${item}');`
        },
    },
}
</script>
